import type { SVGProps } from "react";

/**
 * Shared SVG boundary for onboarding artwork and icons.
 * Feature components should import this instead of rendering raw SVG roots.
 */
export function SvgIcon(props: SVGProps<SVGSVGElement>) {
  return <svg aria-hidden="true" focusable="false" {...props} />;
}
